import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


/**
 * Base UI Components to be imported, 
 * this mandatory to be included so that the View Module Pages can be rendered via baseUI
 */
import { BaseUIContainerComponent } from '../../BaseFramework/base-ui/base-ui-container/base-ui-container.component'
import { AppLayoutComponent } from '../../BaseFramework/base-ui/app-layout/app-layout.component'
////BASEUI Modules End

// import { NBCaptureProposalComponent } from './nb-capture-proposal/nb-capture-proposal.component';
import { PolicyServicingAuthenticationGuard } from './policyServicing-guards'
import { ServicingComponent } from './servicing/servicing.component';


var subroutes = [
    // {
    //     path: 'nb-capture-proposal',
    //     component: NBCaptureProposalComponent,
    //     data: {
    //         breadcrumb: 'Capture Proposal'
    //     },
    // },


];

const routes: Routes = [
    {
        path: '',
        component: BaseUIContainerComponent,
        children: [

            {
                path: 'app/policyServicing',
                component: AppLayoutComponent,
                canActivate: [PolicyServicingAuthenticationGuard],
                children: [
                    ...subroutes
                ]
            },

        ]
    },
    {
        path: 'search-policy',
        component: ServicingComponent,
        data: {
            breadcrumb: 'Search Policy Servicing',
            intimationType: 'NONBRANCH'
        },
    },  
    {
        path: 'search-customer',
        component: ServicingComponent,
        data: {
            breadcrumb: 'Customer 360view ',
            intimationType: 'NONBRANCH'
        },
    },  
    // {path: 'intimation', loadChildren: './intimation/intimation.module#IntimationModule'},
    // {path: 'registration', loadChildren: './registration/registration.module#RegistrationModule'},
    // {path: 'inbox', loadChildren: './inbox/inbox.module#InboxModule'},
    {path: 'transaction', loadChildren: () => import('./transaction/PS-transaction.module').then(m => m.TransactionPolicyServicingModule)},
  
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class PolicyServicingRoutingModule { }
